import { useMemo } from 'react';
import { ColumnTable, Button, Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { ReportAsyncTypeRow } from '../types';
import { TranslationsKeys } from '../../../../../locales/translations';
import ReportHistoryCell from '../parts/ReportHistoryCell';

type UseReportsColumnsProps = {
  onPressGenerate?: (row: ReportAsyncTypeRow) => void;
  onPressHistory?: (row: ReportAsyncTypeRow) => void;
};

export const useReportsColumns = (props: UseReportsColumnsProps) => {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_REPORTS_ASYNC);

  const columns = useMemo<ColumnTable<ReportAsyncTypeRow>[]>(
    () => [
      {
        columnName: 'name',
        thClassName: 'text-left',
        tdClassName: 'text-left',
        headerText: t(`table.name`),
      },
      {
        columnName: 'description',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`table.description`),
      },
      {
        columnName: 'lastGenerated',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`table.lastGenerated`),
        cellFormat: ({ row }) => (
          <ReportHistoryCell
            lastGeneratedDate={row.lastGenerated?.date}
            lastGeneratedUrl={row.lastGenerated?.url}
            generatedBy={row.history?.[0]?.generatedBy?.name}
            periodOrBreakDate={row.history?.[0]?.periodOrBreakDate ?? undefined}
          />
        ),
      },
      {
        columnName: 'history',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`table.history`),
        cellFormat: ({ row }) => (
          <button
            type="button"
            onClick={() => props?.onPressHistory?.(row)}
            style={{
              padding: 0,
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
            }}
          >
            <Icon name="schedule" size={24} />
          </button>
        ),
      },
      {
        columnName: 'id',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`table.action`),
        cellFormat: ({ row }) => (
          <Button
            type="button"
            text={t(row.generating ? `table.generating` : `table.generate`)}
            disabled={row.generating}
            size="sm"
            onClick={() =>
              !!props?.onPressGenerate && props?.onPressGenerate(row)
            }
          />
        ),
      },
    ],
    [t, props],
  );

  return columns;
};
